import { render } from "./EventRoomPlaceholder.vue.js?vue&type=template&id=e3174138!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EventRoomPlaceholder.vue?vue&type=template&id=e3174138"
import script from "./EventRoomPlaceholder.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EventRoomPlaceholder.vue?vue&type=script&lang=js"
export * from "./EventRoomPlaceholder.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EventRoomPlaceholder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/event-page/EventRoomPlaceholder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e3174138"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e3174138', __exports__)) {
    api.reload('e3174138', __exports__)
  }
  
  module.hot.accept("./EventRoomPlaceholder.vue.js?vue&type=template&id=e3174138!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./EventRoomPlaceholder.vue?vue&type=template&id=e3174138", () => {
    api.rerender('e3174138', render)
  })

}


export default __exports__